/* import __COLOCATED_TEMPLATE__ from './validation-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();